import {
  GET_FUNCTION,
  GET_GROUP_FUNCTION,
  ADD_FUNCTION_MAP,
  GET_FUNCTION_GROUP,
  ADD_GROUP_FUNCTION_MAP,
} from '../types'

const INITIAL_STATE = {
  functions: [],
  workflows: [],
  permissions: [],
  functions1: [],
  workflows1: [],
  permissions1: [],
  fnWkMappings: [],
  fnWkMappingsGroup: [],
  allfunctionMapping: [],
  GroupFnMappings: [],
  functionss: [],
  groupss: [],
  permissionss: [],
  groupFunctionMapping: [],
}

const functionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_FUNCTION:
      const { functions, workflows, permissions } = payload
      const permissionsMap = {}
      permissions.forEach((perm) => {
        const key = `${perm.functionId}-${perm.workflowId}`
        permissionsMap[key] = perm.permissions
      })

      const fnWkMappings = permissions.length
        ? functions.map((fn) => {
            const mapping = {
              functionName: fn.name,
              functionId: fn.id,
            }
            workflows.forEach((wf) => {
              const key = `${fn.id}-${wf.id}`
              mapping[wf.id] = permissionsMap[key] || null
            })
            return mapping
          })
        : []

      return {
        ...state,
        functions,
        workflows,
        permissions,
        fnWkMappings,
      }
    case GET_GROUP_FUNCTION:
      var functions1 = payload.functions
      var workflows1 = payload.workflows
      var permissions1 = payload.permissions
      let fnWkMappingsGroup = []
      functions1.forEach((fn) => {
        workflows1.forEach((wf) => {
          let perm = permissions1.find(
            (pm) => pm.functionId === fn.id && pm.workflowId === wf.id,
          )
          let findFnMappingsIndex = fnWkMappingsGroup.findIndex(
            (fnMap) => fnMap.functionId === fn.id,
          )
          if (findFnMappingsIndex >= 0) {
            fnWkMappingsGroup[findFnMappingsIndex] = {
              ...fnWkMappingsGroup[findFnMappingsIndex],
              [wf.id]: perm.permissions1,
            }
          } else {
            fnWkMappingsGroup.push({
              functionName: fn.name,
              functionId: fn.id,
              [wf.id]: perm.permissions1,
            })
          }
        })
      })
      return {
        ...state,
        functions1,
        workflows1,
        permissions1,
        fnWkMappingsGroup,
      }
    case ADD_FUNCTION_MAP:
      return {
        ...state,
        allfunctionMapping: payload.data,
      }

    case GET_FUNCTION_GROUP:
      const { functionss, groupss, permissionss } = payload

      const GPpermissionsMap = {}
      permissionss.forEach((perm) => {
        const key = `${perm.functionId}-${perm.groupId}`
        GPpermissionsMap[key] = perm.permissions
      })

      const GroupFnMappings = permissionss.length
        ? functionss.map((fn) => {
            const mapping = {
              functionName: fn.name,
              functionId: fn.id,
            }
            groupss.forEach((wf) => {
              const key = `${fn.id}-${wf.id}`
              mapping[wf.id] = GPpermissionsMap[key] || null
            })
            return mapping
          })
        : []

      return {
        ...state,
        functionss,
        groupss,
        permissionss,
        GroupFnMappings,
      }

    case ADD_GROUP_FUNCTION_MAP:
      return {
        ...state,
        groupFunctionMapping: payload.data,
      }
    default:
      return state
  }
}

export default functionReducer
